import { t } from '@/features/i18n/utils';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { useSuspenseQuery } from '@tanstack/react-query';
import { procurementDetailsQuery } from '@/features/subcontractor-bids/queries';
import { useUpdateProcurement } from '@/features/subcontractor-bids/mutations';
import { DisciplinePicker } from '@/features/subcontractor-bids/components/discipline-picker';
import { DisciplineSelection } from '@/features/subcontractor-bids/types';
import { Button } from '@/ui/components/button';
import { Form } from '@/ui/components/form';
import { Card } from '@/ui/components/card';
import { H3 } from '@/ui/components/heading';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/subcontractor-bids/$procurementId/settings/disciplines',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { procurementId, workspaceId } = Route.useParams();

  const { data: procurement } = useSuspenseQuery(
    procurementDetailsQuery(workspaceId, procurementId),
  );

  const [selection, setSelection] = useState<DisciplineSelection>({
    disciplines: procurement.disciplines.map((d) => d.slug),
  });
  const [seenProcurement, setSeenProcurement] = useState(procurement);
  if (procurement !== seenProcurement) {
    setSeenProcurement(procurement);
    setSelection({ disciplines: procurement.disciplines.map((d) => d.slug) });
  }

  const updateProcurement = useUpdateProcurement(procurementId);

  return (
    <Form
      onFormSubmit={() => updateProcurement.mutate({ disciplines: selection.disciplines })}
      className="max-w-2xl w-full flex flex-col gap-4"
    >
      <Card className="space-y-4 p-4">
        <H3 className="-mt-1">{t({ en: 'Disciplines', nb: 'Fagområder' })}</H3>
        <DisciplinePicker
          selection={selection}
          onSelectionChange={setSelection}
          disabled={updateProcurement.isPending}
        />
      </Card>
      <Button type="submit" pending={updateProcurement.isPending} className="ml-auto">
        {t({ en: 'Save', nb: 'Lagre' })}
      </Button>
    </Form>
  );
}
